import { atom } from "recoil";

type SectionsPermissionsAtomT = Array<SectionPermissionT>;

const sectionsPermissionsAtom = atom<SectionsPermissionsAtomT>({
  key: "@sections_permissions_atom",
  default: [],
});

export default sectionsPermissionsAtom;
